import React from "react";
import {
  Box,
  Skeleton,
  Grid,
  Paper,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { MovementCardSkeleton } from "./MovementCardSkeleton";

export function BatteryMovementSkeleton() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box>
      <Grid container spacing={2}>
        {[...Array(4)].map((_, i) => (
          <Grid item xs={6} sm={3} key={i}>
            <Skeleton variant="rectangular" height={80} />
          </Grid>
        ))}
      </Grid>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1,
          my: 3,
        }}
      >
        {[...Array(5)].map((_, i) => (
          <Skeleton
            key={i}
            variant="rounded"
            width={isMobile ? 100 : 130}
            height={36}
          />
        ))}
      </Box>

      <Skeleton variant="rounded" height={40} width="60%" />

      <MovementCardSkeleton />
    </Box>
  );
}
